export default "__VITE_ASSET__BQGyXKA6__"